import fetchAPI from '../../../../lib/utils/fetch-api'
import { ReleaseNotesPage } from './types'

export const fetchUnseenReleaseNotes = async (): Promise<ReleaseNotesPage> =>
  (await fetchAPI('/api/release-notes/unseen', {
    cache: 'no-store',
    timeoutMs: 10000,
  })) as unknown as ReleaseNotesPage

export const fetchReleaseNotesHistory = async (page: number): Promise<ReleaseNotesPage> =>
  (await fetchAPI(`/api/release-notes/history?page=${page}`, {
    cache: 'no-store',
    timeoutMs: 10000,
  })) as unknown as ReleaseNotesPage

export const markReleaseNotesViewed = async (ids: string[]): Promise<void> => {
  await fetchAPI('/api/release-notes/viewed', {
    method: 'POST',
    body: JSON.stringify({ ids }),
    timeoutMs: 10000,
  })
}
